import api from "./api";

function tagId(value) {
  if (!["string", "number"].includes(typeof value) || (typeof value === "string" && !/^\d+$/.test(value)) || !Number.isSafeInteger(Number(value)) || Number(value) < 1) throw new Error("Identificador de tag inválido.");
  return Number(value);
}
export function normalizeTagIds(values, limit = 100) {
  if (!Array.isArray(values) || values.length > limit) throw new Error("Escolha até 100 tags.");
  return [...new Set(values.map(tagId))].sort((a, b) => a-b);
}
export async function fetchContactTagsContext(ticketId) {
  return api.get(`/tickets/${tagId(ticketId)}/contact-tags`, { timeout: 20000 });
}
export async function saveContactTags(ticketId, payload) {
  const expectedTagIds = normalizeTagIds(payload.expectedTagIds), addTagIds = normalizeTagIds(payload.addTagIds), removeTagIds = normalizeTagIds(payload.removeTagIds);
  if (addTagIds.some(id => removeTagIds.includes(id))) throw new Error("Uma tag não pode ser adicionada e removida na mesma operação.");
  return api.patch(`/tickets/${tagId(ticketId)}/contact-tags`, { expectedTagIds, addTagIds, removeTagIds }, { timeout: 20000 });
}
export function getTagDelta(baseline, selected) {
  const before = normalizeTagIds(baseline), after = normalizeTagIds(selected, 1000);
  return { addTagIds: after.filter(id => !before.includes(id)), removeTagIds: before.filter(id => !after.includes(id)) };
}
export function rebaseTagSelection(latest, delta, available) {
  const allowed = new Set(available.map(tagId)), removed = new Set(delta.removeTagIds);
  return normalizeTagIds([...latest.filter(id => !removed.has(id)), ...delta.addTagIds.filter(id => allowed.has(id))], 200);
}
